import React, { Component } from 'react'
import {Grid, Button, Modal} from 'semantic-ui-react';
import '../../assets/css/home.css';
import data from '../../assets/json/home/testimonials.json';
import headerBorder from '../../assets/images/line-orange.png';

class Testimonials extends Component {
	state = {
		data: data.testimonials
	};
	
	
  render() {
	var createReactClass = require('create-react-class');
		var ImagePreview = createReactClass({
			getInitialState() {
				return {
				  hover: false,
				  open: false
				};
			},
			openModal(){
				this.setState({open: true});
			},
			closeModal(){
				this.setState({open: false});
			},
			render: function(){
				return (
					<div>
						<div className="testimonial-content-wrapper">
							<img src={this.props.src} alt={this.props.alt} className="testimonial-photo"/>
							<h1 className="content-title">{this.props.name}</h1>
							<p className="para-content-orange margin-top-2 margin-bottom-2">{this.props.position}</p>
							<div className="para-content testimonial-caption">
								<p className="align-center">{this.props.caption}</p>
							</div>
							<Button color='orange' onClick={this.openModal} inverted>&emsp; Read more &emsp;</Button>
						</div>
						<Modal open={this.state.open} onCancel={this.closeModal} size='large' dimmer='blurring'>
							<Modal.Header>{this.props.name}'s  Travel  Testimonial</Modal.Header>
							<Modal.Content>
								<Grid className="testimonial-modal-wrapper">
									<Grid.Column width={5} className="align-center">
										<img src={this.props.src} alt={this.props.alt} className="testimonial-photo"/>
									</Grid.Column>
									<Grid.Column width={11}>
										<p className="para-content">{this.props.para1}</p>
										<p className="para-content">{this.props.para2}</p>
									</Grid.Column>
										
								</Grid>
								
							</Modal.Content>
							<Modal.Actions>				
								<Button negative onClick={this.closeModal} content="Close"/>
							</Modal.Actions>
						</Modal>

					</div>
				);
			}
		});
		
		
		return (
			<div>
				<Grid >
					<Grid.Column width={16} className="align-center">
						<h1 className="section-header align-center">Testimonials</h1>
						<img src={headerBorder} className="header-border align-center" alt="" />
					</Grid.Column>	
				</Grid>
				<Grid className="testimonial-wrapper">
				{
					this.state.data.map((img,i) => (
						<Grid.Column width={6} className="align-center" key={img.id}>
							<ImagePreview
								src={img.photo}
								name={img.name}
								position={img.position}
								caption={img.caption}
								para1={img.para1}
								para2={img.para2}
								alt={img.alt}
							/>
						</Grid.Column>
					))

					
				}
				</Grid>


				

			</div>
        );
	}
}

export default Testimonials;